<div fxLayout="row">
	<span class="employer-title">
		{{ 'employer' | translate }}
		<span class="employer-data" (click)="open()">: {{ company.fullDetails.neoId }} - {{ company.fullDetails.name }}</span>
	</span>
	<mat-icon class="more-details-action" (click)="open()">info</mat-icon>
</div>
